import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { SearchCondition } from 'src/app/shared/model/search-condition.model';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SearchConditionService } from '../../service/search-condition.service';
import { NotificationService } from 'src/app/shared/service/notification.service';
import { SearchService } from 'src/app/shared/service/search/search.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-notification-register',
  templateUrl: './notification-register.component.html',
  styleUrls: ['./notification-register.component.scss']
})
export class NotificationRegisterComponent implements OnInit, OnDestroy {
  @Input() searchParams: SearchCondition;
  @Input() searchService: SearchService;
  filter_enable = true;
  name: string;
  modalRef: NgbActiveModal;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private modalService: NgbModal,
    private toastrService: ToastrService,
    private searchConditionService: SearchConditionService,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {}

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  open(content): void {
    this.modalRef = this.modalService.open(content, {
      windowClass: 'search-tag-register-modal'
    });
  }

  registerNotification(): void {
    const params = {
      ...this.searchParams,
      search_tag_ids: this.searchService.getSearchTagIds()
    };
    const sub = this.notificationService
      .createNotificationFilter({
        name: this.name,
        mail_type: params.mail_type.includes('worker') ? 'worker' : 'project',
        conditions: params,
        enable: this.filter_enable
      })
      .subscribe(_ => this.toastrService.success('ボタン登録に成功しました。'));
    this.subscriptions.add(sub);
    this.name = '';

    this.modalRef.close();
  }

  EnterOnRegister(event): void {
    if (event.key === 'Enter' && !event.isComposing) {
      event.preventDefault();
      this.registerNotification();
    }
  }
}
